module.exports = __webpack_public_path__ + "static/img/banner_01.15890ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner_01.png
// module id = I16o
// module chunks = 1